import axios from "axios";
import {toast} from "../class/Notification";


export const flatMenu = (arr) => {
    return arr.reduce((a, item) => {
        a.push(item);
        if (item.children) {
            a = a.concat(flatMenu(item.children));
        }
        return a;
    }, []);
};

export default {
    namespaced: true,
    state: {
        allMenus: [],
        menu: [],
        state: 0,
        menuItems: [],
        storeMenus: [],
        blogMenus: []
    },
    mutations: {
        setAllMenus(state, Menus) {
            state.allMenus = Menus;
        },
        setMenu(state, Menu) {
            state.menu = Menu
        },
        setMenuItems(state, Items) {
            state.menuItems = Items
        },
        setStoreMenu(state, menus) {
            state.storeMenus = menus
        },
        setBlogMenu(state, menus) {
            state.blogMenus = menus
        }
    },
    actions: {
        getMenus({commit}) {

            axios
                .get("/menu")
                .then((res) => {
                    const menus = res.data.data;
                    console.log('menus are ...', menus)

                    commit("setAllMenus", menus);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getMenu({commit}, menuId) {


            axios
                .get("/menu")
                .then((res) => {
                    const allMenus = res.data.data;
                    let menu = []
                    allMenus.forEach(element => (element.id === parseInt(menuId)) ? menu = element : null)
                    console.log('menu is ...', menu)
                    commit("setMenu", menu);
                    commit("setMenuItems", menu.children)
                })
                .catch((error) => {
                    console.log(error);
                });

        },
        createItem({commit}, form) {
            axios
                .post("/menu-item", form)
                .then((res) => {
                    console.log(res, "create item");
                    this.dispatch("Menu/getMenu", form.menu_id).then(res => {
                        toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد', 'success')
                    })

                })
                .catch((error) => {
                    console.log(error);
                });

        },
        createMenu({commit}, form) {

            axios
                .post("/menu", form)
                .then((res) => {
                    console.log(res, "create menu");
                    this.dispatch("Menu/getMenus").then(r => {
                        toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد', 'success')
                    })

                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deleteMenu({commit}, menuId) {

            axios
                .delete(`/menu/${menuId}`)
                .then((res) => {

                    this.dispatch("Menu/getMenus")

                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deleteItem({commit}, form) {

            axios
                .delete(`/menu-item/${form.id}`)
                .then((res) => {

                    this.dispatch("Menu/getMenu", form.menu_id)

                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updateMenu({commit}, menu) {
            axios
                .put(`/menu/${menu.menu_id}`, menu)
                .then((res) => {
                    this.dispatch("Menu/getMenu", menu.menu_id).then(res => {
                        toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد', 'success')
                    })
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updateItem({commit}, item) {
            axios
                .put(`/menu-item/${item.id}`, item)
                .then((res) => {

                    this.dispatch("Menu/getMenu", item.menu_id).then(res => {
                        toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد', 'success')
                    })
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getStoreMenus({commit}) {

            axios
                .get("/menu/store-menu")
                .then((res) => {
                    const menus = res.data.data;

                    commit("setStoreMenu", menus);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getBlogMenus({commit}) {

            axios
                .get("/menu/blog-menu")
                .then((res) => {
                    const menus = res.data.data;

                    commit("setBlogMenu", menus);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    },
    getters: {
        getAllMenus: (state) => state.allMenus,
        getMenu: (state) => state.menu,
        getMenuItems: (state) => state.menuItems,
        getStoreMenus: (state) => state.storeMenus,
        getBlogMenus: (state) => state.blogMenus


    },
}
